import { Box, Flex, HStack, Image, Text } from "@chakra-ui/react";

import { useEffect, useState } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import { NumericFormat } from "react-number-format";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../../../components/common/DashboardHeader";
import Loading from "../../../components/common/Loading";
import warning from "../../../img/warning.svg";
import no_image from "../../../img/bookpic.jpg";
import { IUser } from "../../../models/auth.model";
import { IGetEnrolmentPayment } from "../../../models/course-enrolment.model";
import { getLocalUserProfile } from "../../../services/auth.service";
import courseEnrolmentService from "../../../services/course-enrolment.service";
import routes from "../../routes";

const DuePayments = () => {
  const [user, setUser] = useState<IUser | null>();

  const navigate = useNavigate();
  const [shortlistedCourses, setshortlistedCourses] = useState<
    IGetEnrolmentPayment[]
  >([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = getLocalUserProfile();
    if (user) {
      setUser(user);
      courseEnrolmentService
        .getPendingPayment(user.id.toString())
        .then((response) => {
          const newlyEnrolledCourse = response.data.filter(
            (each: IGetEnrolmentPayment) => {
              // status 2 is approved and awaiting payment
              if (
                each.course &&
                (each.course?.status === 2 || each.course?.status === 5) &&
                each.payment &&
                each.payment?.amountdue > 0 // if the course isnt paid for completely
              ) {
                return each;
              }
            }
          );

          setshortlistedCourses(newlyEnrolledCourse);
          setLoading(false);
        })
        .catch((err) => err);
    }
  }, []);

  const viewCourse = async (
    course_id: string,
    enrolment_id: string,
    course: any
  ) => {
    navigate(routes.PaymentLink(course_id, enrolment_id), { state: course });
  };

  return (
    <>
      <DashboardHeader />
      <Box bg="#F9F8F8" minHeight="90vh" pt="20px" height={"auto"} pb={"2rem"}>
        <Box
          bg="white"
          fontWeight="700"
          fontSize="20px"
          px="2rem"
          color="#353535"
          width={["90%", "90%", "70%", "60%"]}
          mx="auto"
          pt="20px"
          pb="15px"
          mt="20px"
          mb={"20px"}
          shadow={"md"}
          borderTopRadius="5px"
        >
          Pending Payment(s)
        </Box>

        {loading ? (
          <Loading />
        ) : (
          shortlistedCourses.map((each, index) => {
            return (
              <Box
                bg="white"
                key={index}
                width={["90%", "90%", "70%", "60%"]}
                mb="1.8rem"
                mx="auto"
                pt="10px"
                pb="0.5rem"
                boxShadow="base"
                cursor="pointer"
              >
                <Box p="8px" bg="white" mb="25px" width={"100%"}>
                  {/* <Flex
                    mx="auto"
                    width="87%"
                    bg="white"
                    pb="8px"
                    pt="10px"
                    mb="24px"
                    justifyContent={"space-between"}
                    borderBottom="2px solid"
                    borderColor="gray.200"
                  >
                    
                    <HStack alignContent={"center"}>
                      <Image src={warning} />
                      {each.payment.amountpaid > 0 &&
                      each.payment.amountdue > 0 ? (
                        <Box>
                          <Text
                            ml="10px"
                            fontSize="16px"
                            color="#F79E1B"
                            fontWeight="500"
                          >
                            Balance:
                            <NumericFormat
                              value={each.payment.amountdue}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"₦"}
                            />
                          </Text>
                          <Text
                            ml="10px"
                            fontSize="16px"
                            color="#F79E1B"
                            fontWeight="500"
                            textDecoration="line-through"
                          >
                            <NumericFormat
                              value={each.course.cost}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"₦"}
                            />
                          </Text>
                        </Box>
                      ) : (
                        <Text
                          ml="10px"
                          fontSize="16px"
                          color="#F79E1B"
                          fontWeight="500"
                        >
                          <NumericFormat
                            value={each.course.cost}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"₦"}
                          />
                        </Text>
                      )}
                    </HStack>

                    <Box
                      py="7px"
                      px="9px"
                      bg="#EC3337"
                      borderRadius="2px"
                      color="white"
                      fontSize="13px"
                      fontWeight="600"
                      onClick={() => {
                        viewCourse(
                          each.course.course.uuid,
                          each.course.id.toString()
                        );
                      }}
                    >
                      Pay Now
                    </Box>
                  </Flex> */}
                  <Flex
                    mx="auto"
                    width="87%"
                    bg="white"
                    pb="8px"
                    pt="10px"
                    mb="24px"
                    justifyContent={"space-between"}
                    alignItems="center"
                    borderBottom="2px solid"
                    borderColor="gray.200"
                  >
                    <HStack alignItems={"center"} width="70%">
                      <Image src={warning} />
                      <Box width="100%">
                        {each.payment.amountpaid > 0 &&
                        each.payment.amountdue > 0 ? (
                          <>
                            <Text
                              ml="10px"
                              fontSize="16px"
                              color="#F79E1B"
                              fontWeight="500"
                            >
                              Balance:
                              <NumericFormat
                                value={each.payment.amountdue}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"₦"}
                              />
                            </Text>
                            <Text
                              ml="10px"
                              fontSize="16px"
                              color="#F79E1B"
                              fontWeight="500"
                              textDecoration="line-through"
                            >
                              <NumericFormat
                                value={each.course.cost}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"₦"}
                              />
                            </Text>
                          </>
                        ) : (
                          <Text
                            ml="10px"
                            fontSize="16px"
                            color="#F79E1B"
                            fontWeight="500"
                          >
                            <NumericFormat
                              value={each.course.cost}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"₦"}
                            />
                          </Text>
                        )}
                      </Box>
                    </HStack>

                    <Box
                      width="auto"
                      height="auto"
                      py="7px"
                      px="9px"
                      bg="#EC3337"
                      borderRadius="2px"
                      color="white"
                      fontSize="13px"
                      fontWeight="600"
                      textAlign="center"
                      onClick={() => {
                        viewCourse(
                          each.course.course.uuid,
                          each.course.id.toString(),
                          each
                        );
                      }}
                    >
                      Pay Now
                    </Box>
                  </Flex>

                  <Flex
                    mx="auto"
                    width="87%"
                    bg="white"
                    pb="12px"
                    pt="15px"
                    justifyContent="space-between"
                  >
                    {/* <Box width="47%">
                      <Image
                        objectFit="cover"
                        objectPosition="center"
                        width="100%"
                        height="200px"
                        src={each.course?.course?.cover_image?.toString()}
                      />
                    </Box> */}

                    <Box width="47%">
                      <Image
                        objectFit="fill"
                        height="190px"
                        bgPosition="center"
                        width="100%"
                        src={
                          each.course.course.cover_image
                            ? each.course.course.cover_image
                            : no_image
                        }
                      />
                    </Box>

                    <Box width="47%">
                      <Text
                        color="black"
                        fontSize="22px"
                        textTransform="capitalize"
                        fontWeight="600"
                        mb="21px"
                      >
                        {each.course?.course?.name
                          ? each.course.course.name.toLowerCase()
                          : "Course name not available"}
                      </Text>
                      <Text
                        color="#9E9E9E"
                        fontSize="14px"
                        fontWeight="400"
                        mb="21px"
                      >
                        {each.course?.course?.description
                          ? each.course.course.description.substring(0, 200) +
                            "..."
                          : "Description not available"}
                      </Text>
                    </Box>
                  </Flex>
                </Box>
              </Box>
            );
          })
        )}
      </Box>
    </>
  );
};

export default DuePayments;
